// ============================================================================
// WCF Planner — main.tsx  (application entry)
// ============================================================================
// B3.1: this module is the ROOT and nothing else. It runs the boot steps that
// are not application logic, then renders the provider stack around <App />.
// The application itself lives in src/App.tsx.
//
// Call order is a contract (see src/app/bootstrap/runtimeInit.js):
// initRuntime() must run BEFORE the first render -- the hash rewrite has to
// land before the browser router reads pathname, or a legacy '#webforms' bookmark
// boots to home -- and retireBootLoader() strictly AFTER it.
// ============================================================================

import {createRoot} from 'react-dom/client';
import {AppNavigationRoot, createAppBrowserRouter} from './app/navigation/index.js';
import {initRuntime, retireBootLoader} from './app/bootstrap/runtimeInit.js';
import {assertSurfaceDataManifestRuntime} from './app/data/surfaceDataManifest.js';
import {sb} from './lib/supabase.js';
import {initErrorReporting, installGlobalListeners} from './lib/clientErrorReporting.js';
import ErrorBoundary from './shared/ErrorBoundary.jsx';
import AppProviders from './app/AppProviders.tsx';
import App from './App.tsx';

initErrorReporting(sb);
installGlobalListeners();
initRuntime();
assertSurfaceDataManifestRuntime();

const root = createRoot(document.getElementById('root')!);
const appRouter = createAppBrowserRouter(
  <AppProviders>
    <App />
  </AppProviders>,
);

root.render(
  <ErrorBoundary>
    <AppNavigationRoot router={appRouter} />
  </ErrorBoundary>,
);

// Fade out the static boot loader after React's first paint. STRICTLY AFTER
// root.render() above — runtimeInit books the two animation frames so the
// first frame of real React content is on screen before the spinner goes.
retireBootLoader();
